export default __webpack_public_path__ + "static/media/mithali_raj_2.d393cc46.jpg";